<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_reports'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="">
                <div class="row my-1">
                  <b-form-group class="col-md-4 px-1" label="Date From">
                    <input
                      v-model="datefrom"
                      type="date"
                      required
                      class="form-control"
                    />
                  </b-form-group>
                  <b-form-group class="col-md-4 px-1" label="Date To">
                    <input
                      v-model="dateto"
                      type="date"
                      required
                      class="form-control"
                    />
                  </b-form-group>
                  <div class="col-md-3 mt-md-4 mt-23 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <small><b>Export to </b></small>
                <div class="btn-group">
                  <b-button
                    :disabled="accountsanalysis.length <= 0"
                    type="button"
                    class="btn btn-sm btn-success"
                    @click="printPDF"
                    >PDF <i class="mdi mdi-file-pdf"></i
                  ></b-button>
                  <export-excel
                    type="button"
                    class="btn btn-sm btn-info"
                    :data="accountsanalysis"
                    :name="this.title"
                  >
                    Excel <i class="mdi mdi-file-excel"></i
                  ></export-excel>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive" id="print-section">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(feespayments)="data">
                    {{ commas(data.item.feespayments) }}
                  </template>
                  <template #cell(expenses)="data">
                    {{ commas(data.item.expenses) }}
                  </template>
                  <template #cell(balance)="data">
                    {{ commas(data.item.balance) }}
                  </template>
                </b-table>
              </div>

              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Accounts Analysis Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Accounts Analysis Report",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Accounts Analysis Report", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "method", label: "Account", visible: true },
        { key: "account_number", label: "Account Number", visible: true },
        { key: "feespayments", label: "Fees Payments", visible: true },
        { key: "expenses", label: "Expenses", visible: true },
        { key: "balance", label: "Balance", visible: true },
      ],
      id: "",
      schoolclass: "",
      datefrom: new Date().toLocaleDateString("fr-CA"),
      dateto: new Date().toLocaleDateString("fr-CA"),
      accountsanalysis: [],
    };
  },
  computed: {
    List() {
      return this.accountsanalysis.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.accountsanalysis.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.accountsanalysis.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.TotalRows = this.accountsanalysis.length;
    this.isBusy = false;
  },
  methods: {
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      let formData = new FormData();
      formData.append("datefrom", this.datefrom);
      formData.append("dateto", this.dateto);
      let url = "/accountsanalysis";
      axios.post(url, formData).then((response) => {
        this.accountsanalysis = response.data.cashflows;
      });
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    printPDF() {
      const element = document.getElementById("print-section");
      const options = {
        filename:
          this.title + " : " + this.datefrom + " - " + this.dateto + ".pdf",
        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf()
        .from(element)
        .set(options)
        .save();
    },
  },
};
</script>
